var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 9,
    viewBox: "0 0 34 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03285 4H0.532854V5H1.03285V4ZM33.3207 4.85355C33.516 4.65829 33.516 4.34171 33.3207 4.14645L30.1387 0.964466C29.9435 0.769204 29.6269 0.769204 29.4316 0.964466C29.2364 1.15973 29.2364 1.47631 29.4316 1.67157L32.26 4.5L29.4316 7.32843C29.2364 7.52369 29.2364 7.84027 29.4316 8.03553C29.6269 8.2308 29.9435 8.2308 30.1387 8.03553L33.3207 4.85355ZM1.03285 5H32.9671V4H1.03285V5Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEvents);
export default __webpack_public_path__ + "static/media/ArrowEvents.db63172710e324f57f613332f9512bae.svg";
export { ForwardRef as ReactComponent };